import * as React from 'react';
import { connect } from 'react-redux';
import { Button, ButtonProps } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Selectors
import { Roles } from 'components/RoleGate/types';
import RoleGate from 'components/RoleGate';

interface OwnProps {
    params: {
        [param: string]: any;
    };
    children: React.ReactNode;
    buttonProps?: ButtonProps;
    requiredRoles: Roles[];
    ignoreSeason?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

export type Props = OwnProps & DispatchProps;

/**
 * A button component that adds params to qs when clicked, but only if you have permission.
 */
export class RoleButton extends React.PureComponent<Props> {
    handleClick = (): void => {
        const { params } = this.props;
        this.props.updateQueryString(params);
    };

    render(): React.ReactElement | null {
        const {
            children,
            requiredRoles,
            buttonProps,
            ignoreSeason = false
        } = this.props;

        const baseComponent = (
            <RoleGate requiredRoles={requiredRoles}>
                <Button
                    {...(buttonProps || {
                        circular: true,
                        secondary: true,
                        size: 'small'
                    })}
                    onClick={this.handleClick}
                >
                    {children}
                </Button>
            </RoleGate>
        );

        return ignoreSeason ? (
            baseComponent
        ) : (
            <CurrentSeasonInProgressGate>
                {baseComponent}
            </CurrentSeasonInProgressGate>
        );
    }
}

export default connect(null, { updateQueryString })(RoleButton);
